// extracted by mini-css-extract-plugin
export default {"stats":"UserStatistics_stats__TuFIM","statRow":"UserStatistics_statRow__kROBI","statsButton":"UserStatistics_statsButton__kg0TN","tabClass":"UserStatistics_tabClass__Uymfl"};